import React from "react";

const ShiftAllowancePolicy = () => {
    return <div>ShiftAllowancePolicy</div>;
}

export default ShiftAllowancePolicy;